const TOKEN_KEY = 'adminToken';
const EXPIRY_KEY = 'adminTokenExpiry';
const SIX_HOURS_MS = 6 * 60 * 60 * 1000;

const generateToken = () => {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();
    const bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
};

/** Call after a successful admin login. */
export const setAdminToken = () => {
    localStorage.setItem(TOKEN_KEY, generateToken());
    localStorage.setItem(EXPIRY_KEY, String(Date.now() + SIX_HOURS_MS));
};

/** True only if a token exists and its 6 hours have not passed. */
export const isAdminTokenValid = () => {
    const token = localStorage.getItem(TOKEN_KEY);
    const expiry = Number(localStorage.getItem(EXPIRY_KEY));
    return Boolean(token) && Number.isFinite(expiry) && Date.now() < expiry;
};

export const clearAdminToken = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(EXPIRY_KEY);
};

/** Same home URL you already use in handleLogout. */
export const getHomeUrl = () =>
    window.location.hostname === 'localhost'
        ? 'http://localhost:3000/admin-register'
        : 'https://app.jobbox.one/admin-register';